module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/454.c97b9292.png";